<ion-header class="ion-no-shadow ion-no-border">
    <header-notifications *ngIf="!isPreview"></header-notifications>
    <ion-toolbar *ngIf="showHeader || (limitedMemberList && plt.sizeSm && segment == 'attendees')"
                 class="ion-hide-xl-up">
        <a *ngIf="plt.eventsCount > 1"
           (click)="plt.openEventMenu()"
           class="change-event">
            <svg-icon [applyClass]="true"
                      src="/assets/icons/change-event.svg"></svg-icon>
            <ion-badge *ngIf="plt.unreadOtherCount"
                       class="notification">
                {{ plt.unreadOtherCount }}
            </ion-badge>
        </a>
        <ion-title>
            <ion-item *ngIf="user && user.id && segment != 'marketplace'">
                <img class="logo"
                     width="32"
                     height="32"
                     img-logo
                     [src]="user.selected_participant?.event.logo_url">
                <ion-label>
                    <strong>{{ user.selected_participant?.event.name }}</strong><br />
                    <ng-container *ngIf="!user.selected_participant?.event?.is_community">
                        <ng-container *ngIf="user.selected_participant?.event.date_starts_at.toDateString() != user.selected_participant?.event.date_ends_at.toDateString()">
                            {{ user.selected_participant?.event.date_starts_at | datex:'dateFormatShort' }} -
                        </ng-container>
                        {{ user.selected_participant?.event.date_ends_at | datex }}
                    </ng-container>
                </ion-label>
            </ion-item>
        </ion-title>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding"
             [scrollEvents]="true"
             [ngClass]="{'with-notifications': notificationsVisible, 'attendees': (limitedMemberList && plt.sizeSm && segment == 'attendees')}"
             (ionScroll)="logScrolling($event)">
    <ion-refresher (ionRefresh)="refresh($event)"
                   slot="fixed">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>

    <ion-backdrop *ngIf="showSharing"
                  (ionBackdropTap)="showSharing=false">
    </ion-backdrop>

    <app-out-link></app-out-link>

    <ng-container *ngIf="segment=='info'
                         && !user?.selected_participant?.invisible
                         && user?.selected_participant?.event.is_homepage_content_newsfeed
                         && event?.can(user.selected_participant.group_id, 'allow_newsfeed_post')">
        <!-- fab placed to the bottom end -->
        <ion-fab *ngIf="plt.sizeSm"
                 vertical="bottom"
                 horizontal="end"
                 slot="fixed"
                 class="add-newsfeed-button"
                 (click)="addNewsfedd()">
            <ion-fab-button>
                <svg-icon [applyClass]="true"
                          src="/assets/icons/write.svg"></svg-icon>
            </ion-fab-button>
        </ion-fab>
    </ng-container>

    <ng-container *ngIf="segment=='marketplace'">
        <!-- fab placed to the bottom end -->
        <ion-fab *ngIf="plt.sizeSm
                        && user?.selected_participant
                        && !user?.selected_participant?.invisible
                        && marketplaceList?.marketplace?.post_allowed"
                 vertical="bottom"
                 horizontal="end"
                 slot="fixed"
                 class="add-newsfeed-button"
                 (click)="addMarketplacePost()">
            <ion-fab-button>
                <svg-icon [applyClass]="true"
                          src="/assets/icons/write.svg"></svg-icon>
            </ion-fab-button>
        </ion-fab>
    </ng-container>

    <a *ngIf="plt.tabMenu && plt.eventsCount > 1"
       (click)="plt.openEventMenu()"
       class="change-event no-menu">
        <svg-icon [applyClass]="true"
                  src="/assets/icons/change-event.svg"></svg-icon>
        <ion-badge *ngIf="plt.unreadOtherCount"
                   class="notification">
            {{ plt.unreadOtherCount }}
        </ion-badge>
    </a>

    <div class="content-box dashboard"
         *ngIf="userLang && !loading && user?.id && event && event.id">
        <div class="content-box-inner"
             [ngClass]="{'gray-bg': segment!=='info'}">
            <div *ngIf="!plt.hideDashboardHeader && (segment != 'marketplace' || !plt.sizeSm) && !(limitedMemberList && plt.sizeSm && segment == 'attendees')"
                 [routerLink]="[plt.defaultLink + '/' + homeUrlSegment + '/detail/event']"
                 (click)="tabChanged('detail', 'event')"
                 class="content-header">
                <div class="header-overlay"
                     [ngClass]="{'with-share': event.recommendation.status == 1}">
                    <img class="logo"
                         img-logo
                         [src]="event.logo_url">

                    <ion-grid class="ion-no-padding"
                              *ngIf="event">
                        <ion-row *ngIf="plt.sizeSm"
                                 class="ion-no-padding">
                            <ion-col size="12"
                                     class="ion-no-padding ion-text-center">
                                <h1 class="event-name">{{ event?.translate(event?.default_locale).name }}</h1>
                            </ion-col>
                        </ion-row>
                        <ion-row class="header-top-row ion-no-padding">
                            <ion-col class="left ion-no-padding"
                                     size="6"
                                     size-sm="6">
                                <ion-item *ngIf="!event?.is_community"
                                          class="ion-no-padding">
                                    <svg-icon [applyClass]="true"
                                              src="/assets/icons/ico-calendar.svg"
                                              class="icon fill-light"></svg-icon>
                                    <ion-label class="ion-no-padding ion-no-margin opacity-80">
                                        <ng-container *ngIf="event.date_starts_at.toDateString() != event.date_ends_at.toDateString()">
                                            {{ event.date_starts_at | datex:'dateFormatShort' }} -
                                        </ng-container>
                                        {{ event.date_ends_at | datex }}
                                    </ion-label>
                                </ion-item>
                            </ion-col>
                            <ion-col class="right opacity-80 ion-no-padding ion-padding-right"
                                     size="6"
                                     size-sm="6">
                                <ion-item *ngIf="false && env.useLicenceTotal.includes(event.id)"
                                          class="ion-no-padding ion-float-right">
                                    <svg-icon [applyClass]="true"
                                              src="/assets/icons/ico-attendee.svg"
                                              class="icon fill-light"></svg-icon>
                                    <ion-label *ngIf="event?.participant_count?.total"
                                               class="opacity-80 ion-no-margin ion-padding-left">
                                        <span>{{ event.participant_count.total}} </span> {{ 'DASHBOARD_HEADER_ATTENDEES' | trns }}
                                    </ion-label>
                                    <ion-label *ngIf="!event?.participant_count?.total"
                                               class="opacity-80 ion-no-margin ion-padding-left">
                                        <span>{{ attendeesTotal}} </span> {{ 'DASHBOARD_HEADER_ATTENDEES' | trns }}
                                    </ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="12"
                                     class="ion-text-center">
                                <h1 *ngIf="!plt.sizeSm"
                                    class="event-name">{{ event?.translate(event?.default_locale).name }}</h1>
                                <ng-container *ngIf="segment != 'detail'">
                                    <a class="show-more pointer">{{'DASHBOARD_SHOW_MORE' | trns}}</a>
                                </ng-container>
                                <p *ngIf="segment == 'detail' && event.translate(userLang, event.default_locale).short_description"
                                   class="event-description opacity-80"
                                   [innerHTML]="event.translate(userLang, event.default_locale).short_description | linkify | safe:'html'">
                                </p>
                            </ion-col>
                        </ion-row>
                        <ng-container *ngIf="segment == 'detail' && !event?.is_community">
                            <ion-row>
                                <ion-col size="12"
                                         class="ion-text-center">
                                    <ion-chip *ngIf="event.translate(event?.default_locale).location"
                                              class="location ion-padding">
                                        <svg-icon [applyClass]="true"
                                                  src="/assets/icons/ico-lokace.svg"
                                                  class="icon fill-light"></svg-icon>
                                        <ion-label>{{ event.translate(event?.default_locale).location }}</ion-label>
                                    </ion-chip>
                                </ion-col>
                            </ion-row>
                        </ng-container>
                    </ion-grid>
                    <ion-button *ngIf="event.recommendation.status == 1"
                                (click)="openRecommendation($event)"
                                class="recommendation"
                                color="secondary">
                        {{ event.recommendation.title }}
                    </ion-button>
                    <div *ngIf="showSharing"
                         class="sharing">
                        <ng-container *ngFor="let setting of event.recommendation.setting">
                            <div *ngIf="setting.enabled"
                                 class="share-button"
                                 (click)="share(setting.type)">
                                <svg-icon [applyClass]="true"
                                          [src]="'/assets/icons/share/' + setting.type + '.svg'"
                                          class="icon fill-light">
                                </svg-icon>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>

            <div *ngIf="!plt.tabMenu"
                 class="content-tabs">
                <!-- Default Segment -->
                <ion-segment [(ngModel)]="segment"
                             value="dashboard">
                    <ion-segment-button *ngIf="plt.isConnected"
                                        value="info"
                                        [disabled]="isPreview"
                                        [routerLink]="[plt.defaultLink + '/' + homeUrlSegment + '/info/matching']"
                                        (click)="tabChanged('info', 'matching')">
                        <ion-label *ngIf="event.is_homepage_content_stream"
                                   class="ion-text-uppercase">{{ 'DASHBOARD_SUBMENU_STREAM' | trns }}</ion-label>
                        <ion-label *ngIf="!event.is_homepage_content_stream"
                                   class="ion-text-uppercase">{{ 'DASHBOARD_SUBMENU_DASHBOARD' | trns }}</ion-label>
                    </ion-segment-button>
                    <ion-segment-button *ngIf="plt.isConnected && event.marketplaces.length > 0"
                                        value="marketplace"
                                        [disabled]="isPreview"
                                        [routerLink]="[plt.defaultLink + '/' + homeUrlSegment + '/marketplace/list']"
                                        (click)="tabChanged('marketplace', 'list')">
                        <ion-label class="ion-text-uppercase">
                            <ng-container *ngIf="event.translate(userLang).tab_marketplace">
                                {{ event.translate(userLang).tab_marketplace }}
                            </ng-container>
                            <ng-container *ngIf="!event.translate(userLang).tab_marketplace">
                                {{ 'DASHBOARD_SUBMENU_MARKETPLACE' | trns }}
                            </ng-container>
                        </ion-label>
                    </ion-segment-button>
                    <ion-segment-button *ngIf="plt.isConnected"
                                        value="attendees"
                                        [routerLink]="[plt.defaultLink + '/' + homeUrlSegment + '/attendees/list']"
                                        (click)="tabChanged('attendees','list')">
                        <ion-label *ngIf="!event?.is_community"
                                   class="ion-text-uppercase">{{ 'DASHBOARD_SUBMENU_ATTENDEES' | trns }}</ion-label>
                        <ion-label *ngIf="event?.is_community"
                                   class="ion-text-uppercase">{{ 'DASHBOARD_SUBMENU_ATTENDEES_COMMUNITY' | trns }}</ion-label>
                    </ion-segment-button>
                    <ion-segment-button value="detail"
                                        [routerLink]="[plt.defaultLink + '/' + homeUrlSegment + '/detail/event']"
                                        (click)="tabChanged('detail', 'event')">
                        <ion-label *ngIf="!event?.is_community"
                                   class="ion-text-uppercase">
                            <span class="ion-hide-sm-up">{{ 'DASHBOARD_SUBMENU_EVENT_INFO_SHORT' | trns }}</span>
                            <span class="ion-hide-sm-down">{{ 'DASHBOARD_SUBMENU_EVENT_INFO' | trns }}</span>
                        </ion-label>
                        <ion-label *ngIf="event?.is_community"
                                   class="ion-text-uppercase">
                            <span class="ion-hide-sm-up">{{ 'DASHBOARD_SUBMENU_YOUR_NETWORK' + themeConfig.themeSuffix | trns }}</span>
                            <span class="ion-hide-sm-down">{{ 'DASHBOARD_SUBMENU_YOUR_NETWORK' + themeConfig.themeSuffix | trns }}</span>
                        </ion-label>
                    </ion-segment-button>
                </ion-segment>
            </div>

            <div class="content-data"
                 [ngClass]="{'no-padding': plt.sizeLg && !user.selected_participant?.event.is_homepage_content_matching}">

                <!-- dashboard  -->
                <ng-container *ngIf="segment=='info'">

                    <ion-grid class="ion-no-padding"
                              [ngClass]="{'newsfeed-grid': !user.selected_participant?.event.is_homepage_content_matching}">
                        <ion-row class="ion-no-padding">


                            <ion-col size="12"
                                     size-md="8"
                                     class="ion-no-padding">
                                <!-- keyword settings -->
                                <keyword-settings *ngIf="user.selected_participant?.event.is_homepage_content_matching"
                                                  [view]="view"
                                                  [loadEvent]="false"
                                                  [savedKeywords]="savedKeywords"
                                                  (onShowManageKeywords)="tabChanged('info', 'manage-keywords', false, true)"
                                                  (onShowInterests)="tabChanged('info', 'matching', false, true)"
                                                  (onShowAttendeeList)="tabChanged('attendees', 'list', true)"
                                                  (onChangeLoading)="changeLoading($event)"
                                                  (onChangeDataLoading)="changeDataLoading($event)"
                                                  (onShowAttendeeDetail)="showAttendeeDetail($event)">
                                </keyword-settings>

                                <!-- newsfeed and stream -->
                                <ng-container *ngIf="!user.selected_participant?.event.is_homepage_content_matching">

                                    <div class="set-keywords-banner"
                                         (click)="showKeywordSettings()"
                                         *ngIf="!user.selected_participant.keywords.length && event?.matching_status && !keywordsEmpty">
                                        <ion-grid *ngIf="!plt.sizeMd"
                                                  class="ion-no-padding">
                                            <ion-row class="ion-no-padding">
                                                <ion-col size="12"
                                                         size-md="8"
                                                         class="ion-no-padding">
                                                    <p class="title">{{ 'SELECT_KEYWORDS_BANNER_TITLE' | trns }}</p>
                                                    <p class="opacity-80">{{ 'SELECT_KEYWORDS_BANNER_TEXT' | trns }}</p>
                                                </ion-col>
                                                <ion-col size="12"
                                                         size-md="4"
                                                         class="ion-no-padding ion-text-right">
                                                    <ion-button class="btn"
                                                                color="primary"
                                                                (click)="showKeywordSettings()">
                                                        {{ 'SELECT_KEYWORDS_BANNER_BTN' | trns }}
                                                    </ion-button>
                                                </ion-col>
                                            </ion-row>
                                        </ion-grid>
                                        <ng-container *ngIf="plt.sizeMd">
                                            <p class="title">{{ 'SELECT_KEYWORDS_BANNER_TITLE' | trns }}</p>
                                            <ion-row class="ion-no-padding">
                                                <ion-col class="ion-no-padding">
                                                    <p class="opacity-80">{{ 'SELECT_KEYWORDS_BANNER_TEXT' | trns }}</p>
                                                </ion-col>
                                                <ion-col class="arrow ion-no-padding">
                                                    <ion-icon name="arrow-dropright-circle"></ion-icon>
                                                </ion-col>
                                            </ion-row>
                                        </ng-container>
                                    </div>

                                    <ng-container *ngIf="user.selected_participant?.event.is_homepage_content_newsfeed">
                                        <add-newsfeed *ngIf="!plt.sizeSm && event?.can(user.selected_participant.group_id, 'allow_newsfeed_post') && !user.selected_participant.invisible"
                                                      [showKeywords]="event?.matching_status && !keywordsEmpty"
                                                      [event]="event"
                                                      [user]="user"
                                                      (onNewsfeedSended)="newsfeedSended()"></add-newsfeed>
                                        <newsfeed-list [showKeywords]="event?.matching_status && !keywordsEmpty"
                                                       [event]="event"
                                                       (onNewsfeedEdit)="editNewsfeed($event)">
                                        </newsfeed-list>
                                    </ng-container>

                                    <ng-container *ngIf="user.selected_participant?.event.is_homepage_content_stream">
                                        <stream-list [event]="event"></stream-list>
                                    </ng-container>

                                </ng-container>

                            </ion-col>

                            <!-- appointments and notifications for desktop  -->
                            <ion-col *ngIf="!plt.sizeSm"
                                     size="12"
                                     size-md="4"
                                     class="ion-no-padding">

                                <!-- appointments  -->
                                <ion-card *ngIf="event.appointments && !event.disable_appointments">
                                    <ion-card-header>
                                        <ion-card-title>
                                            <ion-row class="ion-no-padding">
                                                <ion-col class="ion-no-padding">
                                                    {{ 'DASHBOARD_APPOINTMENTS' | trns }}
                                                </ion-col>
                                                <ion-col class="ion-no-padding">
                                                    <a *ngIf="appointmentsLimit < event.appointments.length"
                                                       [routerLink]="[plt.defaultLink + '/appointments']"
                                                       class="show-all">
                                                        {{ 'DASHBOARD_APPOINTMENTS_ALL' | trns:{count: event.appointments.length} }}
                                                    </a>
                                                </ion-col>
                                            </ion-row>
                                        </ion-card-title>
                                    </ion-card-header>

                                    <ion-card-content class="appointments">
                                        <ion-grid *ngIf="event.appointments"
                                                  class="ion-no-padding">
                                            <ion-row *ngIf="event.appointments.length == 0">
                                                <ion-col class="no-records ion-no-padding">
                                                    {{ 'DASHBOARD_APPOINTMENTS_NONE' | trns }}
                                                </ion-col>
                                            </ion-row>
                                            <ng-container *ngFor="let appointment of event.appointments; let c = index">
                                                <ion-row *ngIf="appointmentsLimit > c"
                                                         class="header-top-row pointer ion-no-padding"
                                                         (click)="openAppointmentLink(appointment)">
                                                    <ion-col class="opacity-80 no-grow ion-no-padding ion-align-self-center">
                                                        <svg-icon [applyClass]="true"
                                                                  src="/assets/icons/ico-appointments.svg"
                                                                  class="fill-primary"></svg-icon>
                                                    </ion-col>
                                                    <ion-col class="details ion-no-padding ion-align-self-center">
                                                        <span class="time">
                                                            {{ appointment.date_starts_at | datex:'dateFormatDefault' }}
                                                            {{ appointment.date_starts_at | datex:'timeFormatDefault' }}
                                                            <ng-container *ngIf="appointment.date_ends_at">
                                                                - <span [innerHtml]="appointment.date_ends_at | datex:'timeFormatDefaultEnd'"></span>
                                                            </ng-container>
                                                        </span><br />
                                                        <ng-container *ngIf="appointment.status != 4">

                                                            <ng-container *ngIf="appointment.participants.length <= 2">
                                                                <ng-container *ngFor="let participatnDetail of appointment.participants">
                                                                    <span *ngIf="participatnDetail.id != user.selected_participant.id"
                                                                          class="detail"
                                                                          [innerHtml]="'DASHBOARD_APPOINTMENTS_MEETING_WITH' | trns:{name:(participatnDetail.firstname + ' ' + participatnDetail.lastname)| cut: 42:'... ':false}"></span>
                                                                </ng-container>
                                                            </ng-container>

                                                            <ng-container *ngIf="appointment.participants.length > 2">
                                                                <span class="detail"
                                                                      [innerHtml]="'DASHBOARD_APPOINTMENTS_MEETING_WITH' | trns:{name:(appointment.participantNamesString  | cut: 42:'... ':false)}"></span>
                                                            </ng-container>

                                                        </ng-container>
                                                        <ng-container *ngIf="appointment.status == 4">
                                                            <span class="detail">
                                                                {{ 'APPOINTMENTS_PERSONAL_APPOINTMENT' | trns }}
                                                            </span>
                                                        </ng-container>
                                                    </ion-col>
                                                </ion-row>
                                            </ng-container>
                                        </ion-grid>
                                    </ion-card-content>
                                </ion-card>

                                <!-- notifications  -->
                                <ion-card *ngIf="plt.dashboardFeedsNotVisited">
                                    <ion-card-header (click)="openNotifications()">
                                        <ion-card-title>
                                            <ion-row class="ion-no-padding">
                                                <ion-col class="ion-no-padding">
                                                    {{ 'DASHBOARD_NOTIFICATIONS' | trns | uppercase }}
                                                    <ion-badge *ngIf="plt.dashboardFeedsNotVisited.length"
                                                               margin-left
                                                               color="primary">{{ plt.dashboardFeedsNotVisited.length }}</ion-badge>
                                                </ion-col>
                                            </ion-row>
                                        </ion-card-title>
                                    </ion-card-header>

                                    <ion-card-content class="feed-list ion-no-padding">
                                        <ion-grid class="ion-no-padding">
                                            <ion-row *ngIf="plt.dashboardFeedsNotVisited.length == 0 && plt.dashboardFeedsVisited.length == 0">
                                                <ion-col class="no-records ion-no-padding">
                                                    {{ 'DASHBOARD_NOTIFICATIONS_NONE' | trns }}
                                                </ion-col>
                                            </ion-row>
                                            <ion-row *ngFor="let feed of plt.dashboardFeedsNotVisited"
                                                     class="item {{ feed.data.type }} ion-no-padding">
                                                <ion-col [size]="feed.source_participant && !feed.isMarketplaceType ? 10 : 12"
                                                         (click)="openFeedDetail(feed)"
                                                         class="pointer ion-no-padding">
                                                    <ion-item>
                                                        <div class="picture">
                                                            <ion-avatar *ngIf="!feed.source_participant || feed.isMarketplaceType"
                                                                        class="small-radius">
                                                                <ion-skeleton-text animated></ion-skeleton-text>
                                                                <img img-logo
                                                                     [src]="event.logo_url"
                                                                     [alt]="event.name">
                                                            </ion-avatar>
                                                            <ion-avatar *ngIf="!feed.isMarketplaceType && feed.source_participant && user && user.canPicture(feed.source_participant)"
                                                                        slot="start">
                                                                <img img-avatar
                                                                     [src]="feed.source_participant.picture_url">
                                                            </ion-avatar>
                                                            <ion-avatar *ngIf="feed.source_participant && user && !user.canPicture(feed.source_participant)"
                                                                        slot="start">
                                                                <img img-avatar
                                                                     [src]="''">
                                                            </ion-avatar>
                                                            <svg-icon *ngIf="feed.data.type == 'like' || feed.data.type == 'newsfeed-like' || feed.data.type == 'marketplace-post-like'"
                                                                      [applyClass]="true"
                                                                      src="/assets/icons/ico-like.svg"
                                                                      class="ico-like">
                                                            </svg-icon>
                                                            <svg-icon *ngIf="feed.data.type == 'visit' || feed.data.type == 'marketplace-post-visit'"
                                                                      [applyClass]="true"
                                                                      src="/assets/icons/ico-eye.svg"
                                                                      class="ico-visit">
                                                            </svg-icon>
                                                            <svg-icon *ngIf="feed.data.type == 'message' || feed.data.type == 'newsfeed-comment' || feed.data.type == 'marketplace-post-comment'"
                                                                      [applyClass]="true"
                                                                      src="/assets/icons/ico-message.svg"
                                                                      class="ico-message">
                                                            </svg-icon>
                                                        </div>
                                                        <ion-label>
                                                            <ng-container *ngIf="feed.isMarketplaceType">
                                                                <h2>{{ feed.marketplace.translate(userLang).name }}</h2>
                                                            </ng-container>
                                                            <ng-container *ngIf="!feed.isMarketplaceType">
                                                                <h2 *ngIf="feed.source_participant">{{ feed.source_participant.firstname }} {{ feed.source_participant.lastname }}</h2>
                                                                <h2 *ngIf="!feed.source_participant && feed.data.participant_name">{{ feed.data.participant_name }}</h2>
                                                            </ng-container>

                                                            <p [ngClass]="{'multiline': !feed.source_participant || feed.isMarketplaceType}">
                                                                {{ 'FEED_' + feed.data.type.toUpperCase() + '_TEXT' | trns: {data: feed.data} }}
                                                            </p>
                                                        </ion-label>
                                                    </ion-item>

                                                </ion-col>
                                                <ion-col size="2"
                                                         *ngIf="!feed.isMarketplaceType && feed.source_participant && user && user.canMessage(feed.source_participant) && !feed.source_participant.not_contactable"
                                                         class="open-message"
                                                         (click)="goToConversation(feed.source_participant.id)">
                                                    <svg-icon [applyClass]="true"
                                                              src="/assets/icons/ico-message.svg"
                                                              class="pointer">
                                                    </svg-icon>
                                                </ion-col>
                                            </ion-row>
                                            <hr *ngIf="plt.dashboardFeedsNotVisited.length && plt.dashboardFeedsVisited.length" />
                                            <ion-row *ngFor="let feed of plt.dashboardFeedsVisited"
                                                     class="item visited {{ feed.data.type }} ion-no-padding">
                                                <ion-col [size]="feed.source_participant && !feed.isMarketplaceType ? 10 : 12"
                                                         (click)="openFeedDetail(feed)"
                                                         class="pointer ion-no-padding">
                                                    <ion-item>
                                                        <div class="picture">
                                                            <ion-avatar *ngIf="!feed.source_participant || feed.isMarketplaceType"
                                                                        class="small-radius">
                                                                <ion-skeleton-text animated></ion-skeleton-text>
                                                                <img img-logo
                                                                     [src]="event.logo_url"
                                                                     [alt]="event.name">
                                                            </ion-avatar>
                                                            <ion-avatar *ngIf="!feed.isMarketplaceType && feed.source_participant && user && user.canPicture(feed.source_participant)"
                                                                        slot="start">
                                                                <img img-avatar
                                                                     [src]="feed.source_participant.picture_url">
                                                            </ion-avatar>
                                                            <ion-avatar *ngIf="feed.source_participant && user && !user.canPicture(feed.source_participant)"
                                                                        slot="start">
                                                                <img img-avatar
                                                                     [src]="''">
                                                            </ion-avatar>
                                                            <svg-icon *ngIf="feed.data.type == 'like' || feed.data.type == 'newsfeed-like' || feed.data.type == 'marketplace-post-like'"
                                                                      [applyClass]="true"
                                                                      class="ico-like"
                                                                      src="/assets/icons/ico-like.svg">
                                                            </svg-icon>
                                                            <svg-icon *ngIf="feed.data.type == 'visit' || feed.data.type == 'marketplace-post-visit'"
                                                                      [applyClass]="true"
                                                                      class="ico-visit"
                                                                      src="/assets/icons/ico-eye.svg">
                                                            </svg-icon>
                                                            <svg-icon *ngIf="feed.data.type == 'message' || feed.data.type == 'newsfeed-comment' || feed.data.type == 'marketplace-post-comment'"
                                                                      [applyClass]="true"
                                                                      class="ico-message"
                                                                      src="/assets/icons/ico-message.svg">
                                                            </svg-icon>
                                                        </div>
                                                        <ion-label>
                                                            <ng-container *ngIf="feed.isMarketplaceType">
                                                                <h2>{{ feed.marketplace.translate(userLang).name }}</h2>
                                                            </ng-container>
                                                            <ng-container *ngIf="!feed.isMarketplaceType">
                                                                <h2 *ngIf="feed.source_participant">{{ feed.source_participant.firstname }} {{ feed.source_participant.lastname }}</h2>
                                                                <h2 *ngIf="!feed.source_participant && feed.data.participant_name">{{ feed.data.participant_name }}</h2>
                                                            </ng-container>
                                                            <p [ngClass]="{'multiline': !feed.source_participant || feed.isMarketplaceType}">
                                                                <ng-container *ngIf="feed.data.type == 'newsfeed-created'">
                                                                    <ng-container *ngIf="event.newsfeed_post_visibility == 'keywords-limit'">
                                                                        {{ 'FEED_' + feed.data.type.toUpperCase() + '_TEXT_KEYWORD_LIMIT' | trns: {data: feed.data, count:
                                                                        event.newsfeed_keywords_limit} }}
                                                                    </ng-container>
                                                                    <ng-container *ngIf="event.newsfeed_post_visibility != 'keywords-limit'">
                                                                        {{ 'FEED_' + feed.data.type.toUpperCase() + '_TEXT' | trns: {data: feed.data} }}
                                                                    </ng-container>
                                                                </ng-container>
                                                                <ng-container *ngIf="feed.data.type != 'newsfeed-created'">
                                                                    {{ 'FEED_' + feed.data.type.toUpperCase() + '_TEXT' | trns: {data: feed.data} }}
                                                                </ng-container>
                                                            </p>
                                                        </ion-label>
                                                    </ion-item>
                                                </ion-col>
                                                <ion-col size="2"
                                                         *ngIf="!feed.isMarketplaceType && feed.source_participant && user && user.canMessage(feed.source_participant) && !feed.source_participant.not_contactable"
                                                         class="open-message"
                                                         (click)="goToConversation(feed.source_participant.id)">
                                                    <svg-icon [applyClass]="true"
                                                              src="/assets/icons/ico-message.svg"
                                                              class="pointer">
                                                    </svg-icon>
                                                </ion-col>
                                            </ion-row>
                                        </ion-grid>
                                        <a *ngIf="plt.dashboardFeeds.length > 3"
                                           class="pointer show-all ion-text-right"
                                           (click)="openNotifications()">{{ 'DASHBOARD_NOTIFICATIONS_ALL' | trns }}</a>
                                    </ion-card-content>
                                </ion-card>

                                <!-- keywords  -->
                                <ion-card
                                          *ngIf="event?.matching_status && !keywordsEmpty && user.selected_participant.keywords.length && !user.selected_participant?.event.is_homepage_content_matching">
                                    <ion-card-header>
                                        <ion-card-title>
                                            <ion-row class="ion-no-padding">
                                                <ion-col class="ion-no-padding">
                                                    {{ 'DASHBOARD_KEYWORDS' | trns | uppercase }}
                                                </ion-col>
                                                <ion-col class="ion-no-padding ion-text-right">
                                                    <a (click)="showKeywordSettings()">
                                                        {{ 'KEYWORDS_SETTINGS' | trns }}
                                                    </a>
                                                </ion-col>
                                            </ion-row>
                                        </ion-card-title>
                                    </ion-card-header>

                                    <ion-card-content class="keyword-list ion-no-padding">
                                        <ion-grid class="ion-no-padding">

                                            <ng-container *ngFor="let container of event.containers; let c = index">
                                                <hr class="full"
                                                    *ngIf="c > 0">
                                                <h4><strong>{{c+1}}.</strong> {{ container.translate(userLang, event.default_locale).name | cut: 15}}</h4>
                                                <ion-row class="keyword-box ion-no-padding">
                                                    <ng-container *ngFor="let column of (container.columns === 2 ? [1,2] : [1])">
                                                        <ion-col class="multi-columns ion-no-padding"
                                                                 size="{{ container.columns === 2 ? '6' : '12' }}">
                                                            <br *ngIf="plt.sizeSm && column == 2">
                                                            <h5 *ngIf="container.columns === 2">{{ container.translate(userLang, event.default_locale)['column_' + column + '_name'] | cut: 15 }}</h5>

                                                            <!-- Keywords -->
                                                            <div class="keyword-list-content">
                                                                <ng-container *ngFor="let keyword of getEnabledKeywords(container, column).slice(0, 5); let i = index">
                                                                    <span class="keyword-selected">#{{ keyword.translate(userLang, event.default_locale).name | cut: 15 }}</span>
                                                                </ng-container>
                                                            </div>

                                                        </ion-col>
                                                    </ng-container>

                                                    <ion-col size="12">
                                                        <div *ngIf="(getEnabledKeywords(container, 1).length > 5 || (container.columns === 2 && getEnabledKeywords(container, 2).length > 5))">
                                                            <a class="show-more"
                                                               (click)="showKeywordMatching()"> {{ 'SHOW_MORE' | trns }}</a>
                                                        </div>
                                                    </ion-col>

                                                </ion-row>
                                            </ng-container>

                                        </ion-grid>
                                    </ion-card-content>
                                </ion-card>

                            </ion-col>
                        </ion-row>
                    </ion-grid>

                </ng-container>

                <!-- marketplace post list  -->
                <ng-container *ngIf="segment=='marketplace' && event.marketplaces.length > 0">
                    <ion-row class="ion-no-padding">
                        <ion-col size="12"
                                 class="ion-no-padding">
                            <marketplace-list *ngIf="selectedMarketplace"
                                              #marketplaceList
                                              [marketplace]="selectedMarketplace"
                                              [event]="event"
                                              (onMarketplacePostEdit)="editMarketplace($event)">
                            </marketplace-list>
                        </ion-col>
                    </ion-row>
                </ng-container>

                <!-- attendees list  -->
                <ng-container *ngIf="segment=='attendees'">
                    <div class="attendees">

                        <!-- group tabs  -->
                        <ng-container *ngIf="event.use_groups && event.attendees_tabs.length > 1">
                            <div class="btn-groups"
                                 *ngIf="!plt.sizeSm">
                                <button type="button"
                                        *ngFor="let tab of event.attendees_tabs"
                                        (click)="attendeesTabSelect(tab.id)"
                                        [ngClass]="{ 'active' : selectedAttendeesTabId == tab.id }">
                                    {{ tab.name | customTranslate }}
                                </button>
                            </div>
                            <ion-row *ngIf="plt.sizeSm"
                                     class="ion-no-padding ion-align-items-center">
                                <ion-col>
                                    <ion-select [interface]="selectType"
                                                [interfaceOptions]="{cssClass:'not-overflow'}"
                                                [cancelText]="'BUTTON_CANCEL' |  translate"
                                                [placeholder]="'ATTENDEES_TABS_SHOW_ALL' | trns"
                                                name="attendees-tab-select"
                                                id="attendees-tab-select"
                                                #category_id="ngModel"
                                                [(ngModel)]="selectedAttendeesTabId"
                                                (ngModelChange)="attendeesTabSelect($event)">
                                        <ion-select-option [value]="0">{{ 'ATTENDEES_TABS_SHOW_ALL' | trns }}</ion-select-option>
                                        <ion-select-option *ngFor="let tab of event.attendees_tabs"
                                                           [value]="tab.id">
                                            {{ tab.name | customTranslate }}
                                        </ion-select-option>
                                    </ion-select>
                                </ion-col>
                            </ion-row>
                        </ng-container>

                        <!-- filter, count selector  -->
                        <ion-row class="search-line ion-no-padding">
                            <ion-col *ngIf="(!limitedMemberList || (filtered && !showSearchForm)) && !plt.sizeSm"
                                     size-sm="7"
                                     class="limit-setting ion-no-padding">
                                <ion-select #attendee_limit="ngModel"
                                            [interface]="'popover'"
                                            [interfaceOptions]="{cssClass:'limit not-overflow'}"
                                            [(ngModel)]="attendeesLimit"
                                            (ionChange)="setAttendeePage(1)"
                                            name="attendee_limit"
                                            class="blank filter-select">
                                    <ng-container *ngFor="let value of attendeesLimitValues; let c = index">
                                        <ion-select-option *ngIf="c == 0 || c == (attendeesLimitValues.length -1) || value.value < attendeesTotal"
                                                           [value]="value.value">
                                            {{value.name}}
                                        </ion-select-option>
                                    </ng-container>
                                </ion-select>
                                <ion-label *ngIf="!event?.is_community"
                                           [innerHTML]="'ATTENDEE_LIST_ATTENDEES_OF_COUNT' | trns:{count: attendeesTotal}">
                                </ion-label>
                                <ion-label *ngIf="event?.is_community"
                                           [innerHTML]="'ATTENDEE_LIST_ATTENDEES_OF_COUNT_COMMUNITY' | trns:{count: attendeesTotal}">
                                </ion-label>
                                <ion-button *ngIf="(!limitedMemberList || (filtered && !showSearchForm))  && !plt.sizeSm && ((event.matching_status && !keywordsEmpty && (selectedKeywordIds && selectedKeywordIds.length)) || (selectedAddress || attendeesSearch || likes || bookmarks || (selectedCounties && selectedCounties.length)))"
                                            color="secondary"
                                            class="btn-clear-search ion-no-margin"
                                            (click)="clearExtendedFilter()">
                                    {{ 'ATTENDEE_LIST_BTN_CLEAR_SEARCH' | trns }}
                                    <svg-icon [applyClass]="true"
                                              src="/assets/icons/ico-close.svg">
                                    </svg-icon>
                                </ion-button>
                            </ion-col>
                            <ion-col class="flex ion-no-padding ion-align-items-center"
                                     [ngClass]="{'ion-justify-content-end': !plt.sizeSm, 'ion-justify-content-around': plt.sizeSm}">
                                <ng-container *ngIf="!limitedMemberList || (filtered && !showSearchForm)">
                                    <div *ngIf="!plt.sizeSm"
                                         class="view-type-switch ion-no-padding">
                                        <svg-icon [applyClass]="true"
                                                  (click)="changeViewType('lines')"
                                                  [ngClass]="{'active': viewType == 'lines'}"
                                                  src="/assets/icons/ico-lines.svg"
                                                  class="opened">
                                        </svg-icon>
                                        <svg-icon [applyClass]="true"
                                                  (click)="changeViewType('grid')"
                                                  [ngClass]="{'active': viewType == 'grid'}"
                                                  src="/assets/icons/ico-grid.svg"
                                                  class="opened">
                                        </svg-icon>
                                    </div>

                                    <!-- <ion-searchbar *ngIf="!event.matching_status || keywordsEmpty"
                                               [(ngModel)]="attendeesSearch"
                                               (ionChange)="setAttendeePage(1)"
                                               [placeholder]=" 'ATTENDEE_LIST_SEARCH_PLACEHOLDER' | trns"></ion-searchbar> -->

                                    <ion-button class="btn-search"
                                                color="secondary"
                                                (click)="showCommunityFilter()">
                                        <ion-icon slot="start"
                                                  name="search"></ion-icon>
                                        {{ 'ATTENDEE_LIST_BTN_SEARCH' | trns }}
                                    </ion-button>
                                </ng-container>
                                <span class="open-filter"
                                      color="secondary"
                                      [ngClass]="{'with-filter': limitedMemberList && (!filtered || showSearchForm)}"
                                      (click)="showFilter($event)">{{'ATTENDEE_LIST_SHOW_FILTER' | trns }}
                                    <svg-icon [applyClass]="true"
                                              src="/assets/icons/ico-arrow.svg"
                                              class="collapsible">
                                    </svg-icon>
                                    <ion-chip *ngIf="likes || bookmarks">
                                        <ng-container *ngIf="likes == bookmarks">2</ng-container>
                                        <ng-container *ngIf="likes != bookmarks">1</ng-container>
                                    </ion-chip>
                                </span>

                            </ion-col>
                        </ion-row>

                        <community-filter *ngIf="limitedMemberList"
                                          [ngClass]="{'hidden': !showSearchForm, 'notificationsVisible': notificationsVisible}"
                                          [modal]="false"
                                          (applyFilter)="applyFilter($event)"
                                          [attendeesSearch]="attendeesSearch"
                                          [selectedKeywordIds]="selectedKeywordIds"
                                          [enableDistance]="false">
                        </community-filter>

                        <ion-row *ngIf="(!limitedMemberList || (filtered && !showSearchForm)) && plt.sizeSm"
                                 class="mobile-info ion-no-padding ion-align-items-center">
                            <ion-col class="mobile-count-of-attendees ion-no-padding">
                                <strong>{{ attendeesTotal }}</strong>
                                <ng-container *ngIf="!event?.is_community"> {{ 'ATTENDEE_LIST_NUMBER_OF_ATTENDEES' | trns }}</ng-container>
                                <ng-container *ngIf="event?.is_community"> {{ 'ATTENDEE_LIST_NUMBER_OF_ATTENDEES_COMMUNITY' | trns }}</ng-container>
                            </ion-col>
                            <ion-col class="view-type-switch ion-no-padding">
                                <svg-icon [applyClass]="true"
                                          (click)="changeViewType('lines')"
                                          [ngClass]="{'active': viewType == 'lines'}"
                                          src="/assets/icons/ico-lines.svg"
                                          class="opened"></svg-icon>
                                <svg-icon [applyClass]="true"
                                          (click)="changeViewType('grid')"
                                          [ngClass]="{'active': viewType == 'grid'}"
                                          src="/assets/icons/ico-grid.svg"
                                          class="opened"></svg-icon>
                            </ion-col>
                        </ion-row>

                        <ion-row *ngIf="!limitedMemberList && plt.sizeSm"
                                 class="ion-no-padding">
                            <ion-col class="ion-no-padding">
                                <ion-button *ngIf="(event.matching_status && !keywordsEmpty && (selectedKeywordIds && selectedKeywordIds.length)) || (selectedAddress || attendeesSearch || likes || bookmarks || (selectedCounties && selectedCounties.length))"
                                            color="secondary"
                                            class="btn-clear-search ion-no-margin"
                                            (click)="clearExtendedFilter()">
                                    {{ 'ATTENDEE_LIST_BTN_CLEAR_SEARCH' | trns }}
                                    <svg-icon [applyClass]="true"
                                              src="/assets/icons/ico-close.svg"></svg-icon>
                                </ion-button>
                            </ion-col>
                        </ion-row>

                        <ng-container *ngIf="dataLoading && visibleAttendees.length == 0">
                            <div class="content-centered-column">
                                <div class="content-centered-row">
                                    <ion-spinner></ion-spinner>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="(!dataLoading || visibleAttendees.length) && (!limitedMemberList || (filtered && !showSearchForm))">

                            <!-- mobile attendee list  -->
                            <div class="attendee-list-mobile"
                                 *ngIf="viewType == 'lines'">
                                <ng-container *ngFor="let attendee of visibleAttendees; let c = index">
                                    <attendee-list-item [attendee]="attendee"
                                                        [viewType]="viewType"
                                                        [isPreview]="isPreview"
                                                        [hideMatching]="env.hideRatingInMembers"
                                                        [tutorial]="c == 0"
                                                        (onAttendeeDetail)="showAttendeeDetail($event)">
                                    </attendee-list-item>
                                </ng-container>
                            </div>

                            <!-- desktop attendee list  -->
                            <div *ngIf="viewType == 'grid'"
                                 class="attendee-list">
                                <ng-container *ngFor="let attendee of visibleAttendees; let c = index">
                                    <attendee-list-item [attendee]="attendee"
                                                        [viewType]="viewType"
                                                        [isPreview]="isPreview"
                                                        [hideMatching]="env.hideRatingInMembers"
                                                        (onAttendeeDetail)="showAttendeeDetail($event)">
                                    </attendee-list-item>
                                </ng-container>

                                <ng-container *ngIf="!plt.tabMenu">
                                    <ng-container *ngFor="let i of countSizes[5]; let c = index">
                                        <ng-container *ngIf="c < (5 - (visibleAttendees.length % 5)) && visibleAttendees.length % 5 != 0">
                                            <div class="attendee-box-empty"></div>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>

                                <ng-container *ngIf="plt.tabMenu">
                                    <ng-container *ngFor="let i of countSizes[plt.attendeesPerLine]; let c = index">
                                        <ng-container *ngIf="c < (plt.attendeesPerLine - (visibleAttendees.length % plt.attendeesPerLine)) && visibleAttendees.length % plt.attendeesPerLine != 0">
                                            <div class="attendee-box-empty"></div>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </div>

                            <!-- pager for desktop -->
                            <ion-row *ngIf="plt.attendeesPerLine == 5 && pager && pager.pages && pager.pages.length > 1"
                                     class="paginator ion-no-padding">
                                <ion-col class="ion-no-padding ion-text-center">
                                    <ion-button [disabled]="pager.currentPage === 1"
                                                color="white"
                                                (click)="setAttendeePage(1)">{{ 'PAGINATOR_FIRST' | trns }}
                                    </ion-button>
                                    <ion-button [disabled]="pager.currentPage === 1"
                                                color="white"
                                                (click)="setAttendeePage(pager.currentPage - 1)">{{ 'PAGINATOR_PREVIOUS' | trns }}
                                    </ion-button>
                                    <ion-button *ngFor="let page of pager.pages"
                                                class="pages"
                                                [color]="pager.currentPage === page ? 'primary':'white'"
                                                [ngClass]="{active:pager.currentPage === page}"
                                                (click)="setAttendeePage(page)">{{page}}
                                    </ion-button>
                                    <ion-button [disabled]="pager.currentPage === pager.totalPages"
                                                color="white"
                                                (click)="setAttendeePage(pager.currentPage + 1)">{{ 'PAGINATOR_NEXT' | trns }}
                                    </ion-button>
                                    <ion-button *ngIf="attendeesTotal < plt.openSearchLimit"
                                                [disabled]="pager.currentPage === pager.totalPages"
                                                color="white"
                                                (click)="setAttendeePage(pager.totalPages)">{{ 'PAGINATOR_LAST' | trns }}
                                    </ion-button>
                                </ion-col>
                            </ion-row>

                            <ion-infinite-scroll *ngIf="attendeesTotal > 0 && plt.attendeesPerLine != 5"
                                                 threshold="100px"
                                                 (ionInfinite)="loadData($event)">
                                <ion-infinite-scroll-content *ngIf="!event?.is_community"
                                                             loadingSpinner="bubbles"
                                                             [loadingText]="'ATTENDEE_LIST_LOADING_MORE_ATTENDEES' | trns">
                                </ion-infinite-scroll-content>
                                <ion-infinite-scroll-content *ngIf="event?.is_community"
                                                             loadingSpinner="bubbles"
                                                             [loadingText]="'ATTENDEE_LIST_LOADING_MORE_ATTENDEES_COMMUNITY' | trns">
                                </ion-infinite-scroll-content>
                            </ion-infinite-scroll>
                        </ng-container>
                    </div>
                </ng-container>


                <!-- event information  -->
                <ng-container *ngIf="segment=='detail'">
                    <div class="event-info">

                        <div *ngIf="(!event.no_address && event.lat && event.lng) || event.public_email || event.public_phone"
                             class="event-location">
                            <ng-container *ngIf="!event.no_address && event.lat && event.lng">
                                <a href="https://www.google.com/maps/search/?api=1&query={{ event.lat }},{{ event.lng }}"
                                   onclick="window.open(this.href, '_system');return false"
                                   class="gmap-box">
                                    <!-- https://developers.google.com/maps/documentation/maps-static/start -->
                                    <img class="gmap"
                                         [src]="'https://maps.googleapis.com/maps/api/staticmap?center=' + event.lat + ',' + event.lng + '&markers=|' + event.lat + ',' + event.lng + '&zoom=14&size=300x112&key=' + env.google.apiKeys.web"
                                         alt="" />
                                </a>
                                <a class="info"
                                   href="https://www.google.com/maps/search/?api=1&query={{ event.lat }},{{ event.lng }}"
                                   onclick="window.open(this.href, '_system');return false">
                                    <p><strong>{{ event.translate(userLang).location }}</strong></p>
                                    <p>{{ event.address }}</p>
                                    <p>{{ event.zip }}, {{ event.city }}</p>
                                </a>
                            </ng-container>
                            <div *ngIf="event.public_email || event.public_phone"
                                 class="contact">
                                <a *ngIf="event.public_email"
                                   class="email"
                                   [attr.href]="'mailto:' + event.public_email">
                                    <svg-icon [applyClass]="true"
                                              src="/assets/icons/ico-mail.svg">
                                    </svg-icon>
                                    {{ event.public_email }}
                                </a>
                                <a *ngIf="event.public_phone"
                                   [attr.href]="'tel:' + event.public_phone">
                                    <svg-icon [applyClass]="true"
                                              src="/assets/icons/ico-phone.svg">
                                    </svg-icon>
                                    {{ event.public_phone }}
                                </a>
                            </div>
                        </div>
                        <!-- Mobile links which will open modal -->
                        <ng-container *ngIf="plt.tabMenu">
                            <ng-container *ngFor="let block of blocks; let c = index">
                                <div *ngIf="event.translate(userLang)[block.key] || (block.customLabel && block.customLabel.translateOrNew(userLang).external_link)"
                                     class="dropdown detail right-arrow">
                                    <div class="dropdown-header"
                                         (click)="showEventDetail(block)">
                                        <hr />
                                        <h2 class="uppercase">{{ block.title | trns}}</h2>
                                        <svg-icon [applyClass]="true"
                                                  src="/assets/icons/ico-arrow.svg">
                                        </svg-icon>
                                    </div>

                                </div>
                            </ng-container>
                        </ng-container>
                        <!-- Desktop links which open detail -->
                        <ng-container *ngIf="!plt.tabMenu">
                            <ng-container *ngFor="let block of blocks; let c = index">
                                <div *ngIf="event.translate(userLang)[block.key] || (block.customLabel && block.customLabel.translateOrNew(userLang).external_link)"
                                     class="dropdown detail"
                                     [ngClass]="{'opened': block.opened}">
                                    <div class="dropdown-header"
                                         (click)="blockChanged(block)">
                                        <hr />
                                        <h2 class="uppercase">{{ block.title | trns}}</h2>
                                        <svg-icon [applyClass]="true"
                                                  src="/assets/icons/ico-arrow.svg">
                                        </svg-icon>
                                    </div>
                                    <div class="dropdown-content">
                                        <div class="fr-view"
                                             [innerHTML]="event.translate(userLang)[block.key] | linkify | securedImages | safe:'html'">
                                        </div>
                                        <ng-container *ngIf="block.customLabel && block.customLabel.translateOrNew(userLang).external_link">
                                            <ng-container *ngIf="!block.customLabel.translateOrNew(userLang).external_link_doc">
                                                <iframe class="p-w-md"
                                                        frameBorder="0"
                                                        width="100%"
                                                        [height]="frameHeight+'px'"
                                                        sandbox="allow-scripts allow-same-origin allow-forms allow-presentation allow-popups"
                                                        [ngClass]="{'hidden': !block.opened || !block.customLabel.loadedIframe}"
                                                        (load)="onLoad(block.customLabel.key)"
                                                        [src]="block.customLabel.translateOrNew(userLang).external_link | safe:'resourceUrl'">
                                                </iframe>
                                            </ng-container>
                                            <ng-container *ngIf="block.customLabel.translateOrNew(userLang).external_link_doc">
                                                <iframe class="p-w-md"
                                                        frameBorder="0"
                                                        width="100%"
                                                        [height]="frameHeight+'px'"
                                                        [ngClass]="{'hidden': !block.opened || !block.customLabel.loadedIframe}"
                                                        (load)="onLoad(block.customLabel.key)"
                                                        [src]="block.customLabel.translateOrNew(userLang).external_link | safe:'resourceUrl'">
                                                </iframe>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </ng-container>

            </div>
        </div>
    </div>
    <ng-container *ngIf="loading || !user || !event || !user.id">
        <div class="content-centered-column">
            <div class="content-centered-row">
                <ion-spinner></ion-spinner>
            </div>
        </div>
    </ng-container>
</ion-content>